import { createSlice } from "@reduxjs/toolkit";
import { 
    getTodayFinances, 
    getFinances, 
    getGeneralFinances,
    getDailyReport,
    getWeeklyReport,
    getMonthlyReport,
    getYearlyReport,
    getSalesDetails
} from "./thunk";

export const initialState = {
    finances: [],
    todayFinances: [],
    generalFinances: {
        totalAvailable: 0,
        totalSold: 0,
        totalOnHold: 0,
        totalItems: 0,
        totalAvailableItems: 0,
        totalSoldItems: 0,
        totalOnHoldItems: 0
    },
    dailyReport: [],
    weeklyReport: [],
    monthlyReport: [],
    yearlyReport: [],
    salesDetails: [],
    loading: false,
    error: {}
};
const FinanceSlice = createSlice({
  name: "FinanceSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {  
    builder.addCase(getFinances.fulfilled, (state, action) => {
        state.finances = action.payload;
        sessionStorage.setItem("finances", JSON.stringify(state.finances));
    });
    builder.addCase(getTodayFinances.fulfilled, (state, action) => {
      state.todayFinances = action.payload;
      sessionStorage.setItem("todayFinances", JSON.stringify(state.todayFinances));
  });
    builder.addCase(getGeneralFinances.fulfilled, (state, action) => {
        state.generalFinances = action.payload;
        sessionStorage.setItem("generalFinances", JSON.stringify(state.generalFinances));
    });
    builder.addCase(getTodayFinances.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(getFinances.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(getGeneralFinances.rejected, (state, action) => { state.error = action.payload || null; });

    // Daily Report
    builder.addCase(getDailyReport.pending, (state) => { state.loading = true; });
    builder.addCase(getDailyReport.fulfilled, (state, action) => {
        state.dailyReport = action.payload;
        state.loading = false;
    });
    builder.addCase(getDailyReport.rejected, (state, action) => { 
        state.error = action.payload || null;
        state.loading = false;
    });

    // Weekly Report
    builder.addCase(getWeeklyReport.pending, (state) => { state.loading = true; });
    builder.addCase(getWeeklyReport.fulfilled, (state, action) => {
        state.weeklyReport = action.payload;
        state.loading = false;
    });
    builder.addCase(getWeeklyReport.rejected, (state, action) => { 
        state.error = action.payload || null;
        state.loading = false;
    });

    // Monthly Report
    builder.addCase(getMonthlyReport.pending, (state) => { state.loading = true; });
    builder.addCase(getMonthlyReport.fulfilled, (state, action) => {
        state.monthlyReport = action.payload;
        state.loading = false;
    });
    builder.addCase(getMonthlyReport.rejected, (state, action) => { 
        state.error = action.payload || null;
        state.loading = false;
    });

    // Yearly Report
    builder.addCase(getYearlyReport.pending, (state) => { state.loading = true; });
    builder.addCase(getYearlyReport.fulfilled, (state, action) => {
        state.yearlyReport = action.payload;
        state.loading = false;
    });
    builder.addCase(getYearlyReport.rejected, (state, action) => { 
        state.error = action.payload || null;
        state.loading = false;
    });

    // Sales Details
    builder.addCase(getSalesDetails.pending, (state) => { state.loading = true; });
    builder.addCase(getSalesDetails.fulfilled, (state, action) => {
        state.salesDetails = action.payload;
        state.loading = false;
    });
    builder.addCase(getSalesDetails.rejected, (state, action) => { 
        state.error = action.payload || null;
        state.loading = false;
    });
  },
});

export default FinanceSlice.reducer;